/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 * @generated-id: 212522b940e7
 */

import * as z from "zod";
import { ApiError, ApiError$zodSchema } from "./apierror.js";
import {
  AssetRelationsDeleteResponse,
  AssetRelationsDeleteResponse$zodSchema,
} from "./assetrelationsdeleteresponse.js";
import {
  UnrelateAssetsByAssetIdRequest,
  UnrelateAssetsByAssetIdRequest$zodSchema,
} from "./unrelateassetsbyassetidrequest.js";

export type DeleteAssetRelationsByAssetIdGlobals = {
  cloud_name?: string | undefined;
};

export const DeleteAssetRelationsByAssetIdGlobals$zodSchema: z.ZodType<
  DeleteAssetRelationsByAssetIdGlobals
> = z.object({
  cloud_name: z.string().describe("The cloud name of your product environment.")
    .optional(),
});

export type DeleteAssetRelationsByAssetIdRequest = {
  asset_id: string;
  unrelate_assets_by_asset_id_request: UnrelateAssetsByAssetIdRequest;
};

export const DeleteAssetRelationsByAssetIdRequest$zodSchema: z.ZodType<
  DeleteAssetRelationsByAssetIdRequest
> = z.object({
  asset_id: z.string().describe(
    "The asset ID of the resource. Must be a 32-character hexadecimal string.",
  ),
  unrelate_assets_by_asset_id_request: UnrelateAssetsByAssetIdRequest$zodSchema
    .describe("The asset IDs to unrelate."),
});

export type DeleteAssetRelationsByAssetIdResponse =
  | ApiError
  | AssetRelationsDeleteResponse;

export const DeleteAssetRelationsByAssetIdResponse$zodSchema: z.ZodType<
  DeleteAssetRelationsByAssetIdResponse
> = z.union([
  ApiError$zodSchema,
  AssetRelationsDeleteResponse$zodSchema,
]);
